import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ObjectUtils } from 'app/shared/utils/object.utils';
import { TranslationService } from 'app/shared/services/translation.service';
import { BufferConfigGroupLike } from '../../buffer.service';

interface BufferConfigGroupFormLike {
  distanceInMeters: FormControl<number>;
  color: FormControl<string>;
  opacity: FormControl<number>;
}

@Component({
  selector: 'app-buffer-form',
  templateUrl: 'buffer-form.component.html',
  styleUrls: ['buffer-form.component.scss'],
})
export class BufferFormComponent implements OnChanges {
  @Input()
  visible: boolean;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Output()
  valueChange = new EventEmitter<BufferConfigGroupLike>(true);

  @Input()
  value: BufferConfigGroupLike;

  private _lastValue: BufferConfigGroupLike;

  formGroup: FormGroup<BufferConfigGroupFormLike>;

  constructor(
    private formBuilder: FormBuilder,
    private translationService: TranslationService
  ) {
    this.formGroup = this.formBuilder.group<BufferConfigGroupFormLike>({
      distanceInMeters: this.formBuilder.control<number>(null, [
        Validators.required,
        Validators.min(1),
      ]),
      color: this.formBuilder.control<string>(null, [
        Validators.required,
      ]),
      opacity: this.formBuilder.control<number>(null, [Validators.required]),
    });
  }

  get bufferText(): string {
    return this.translationService.getCurrentLanguage()['buffer'];
  }

  get distanceMetersText(): string {
    return this.translationService.getCurrentLanguage()['distance-meters'];
  }

  get colorText(): string {
    return this.translationService.getCurrentLanguage()['color'];
  }

  get transparencyText(): string {
    return this.translationService.getCurrentLanguage()['transparency'];
  }

  get cancelText(): string {
    return this.translationService.getCurrentLanguage()['cancel'];
  }

  get applyText(): string {
    return this.translationService.getCurrentLanguage()['apply'];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.handleValues();
    }
  }

  onHiddenInternal() {
    if (this._lastValue) {
      this.formGroup.reset(this._lastValue);
    }
  }

  onBtnCancelClick() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onSubmit(e) {
    e?.preventDefault();

    if (this.formGroup.invalid) {
      return;
    }

    const values = this.formGroup.getRawValue();
    this._lastValue = null;
    this.value = values;
    this.valueChange.emit(this.value);

    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  private handleValues() {
    this._lastValue = ObjectUtils.clone(this.value);
    this.formGroup.reset(this.value);
  }
}
